import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { OperatingSystem } from '@nora-monorepo/nora-api-client';

import type { UseElementBreakpointsReturn } from '#ui-shared/utils/use-element-breakpoints';

export const useDeviceStore = defineStore('device', () => {
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const operatingSystem = getOs();

  const isMobile = ref(breakpoints.smaller('md').value);
  const isTablet = ref(breakpoints.between('md', 'lg').value);
  const isDesktop = ref(breakpoints.greater('lg').value);
  const isLargeDesktop = ref(breakpoints.greater('xl').value);
  const isExtraLargeDesktop = ref(breakpoints.greater('2xl').value);

  const setBreakpoints = (breakpoints: UseElementBreakpointsReturn<string>): void => {
    isMobile.value = breakpoints.smaller('md').value;
    isTablet.value = breakpoints.between('md', 'lg').value;
    isDesktop.value = breakpoints.greater('lg').value;
    isLargeDesktop.value = breakpoints.greater('xl').value;
    isExtraLargeDesktop.value = breakpoints.greater('2xl').value;
  };

  // TODO: We might want to use a custom useragent definition or send an event from the apps telling the webview what
  //  OS it is to prevent from running webview code in the device browser
  function getOs(): OperatingSystem {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
      return OperatingSystem.ANDROID;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return OperatingSystem.IOS;
    }

    return OperatingSystem.WEB;
  }

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    isExtraLargeDesktop,
    setBreakpoints,
    operatingSystem,
  };
});
